import React from "react";
import { ResourceEnum } from "src/constants/constants.ts";
import type { ModuleOptions } from "src/system/module.types.ts";
import type { SupplierResource } from "@exonn/js-sdk";

export const module: ModuleOptions<SupplierResource> = {
  resource: ResourceEnum.Supplier,
  bigIcon: <i className="icon-20-suppliers" />,
  smallIcon: <i className="icon-15-suppliers" />,

  tabs: {
    edit: {
      titleProp: "number",
    },
  },
};
